import { TextField } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Helmet } from "react-helmet";
import { Calendar } from "react-multi-date-picker";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Get, Set } from "../../../../Request";
import { Color } from "../../../../Utils/styles";
import { cutText } from "../../../../Web/Common/Function";
import HorizentalCard from "../../../Admin/View/Dashboard/Components/HorizentalCard";
import LineChart from "../../../Admin/View/Dashboard/Components/LineChart";
import BoxShadow from "../../../Common/Components/BoxShadow";
import DataTable from "../../../Common/Components/DataTable";
import EditItem from "../../../Common/Components/EditTimeTable";
import Loading from "../../../Common/Components/Loading";
import CustomModal from "../../../Common/Components/Modal/CustomModal";
import OrderList from "../../../Common/Components/OrlderList";
import TimePicker from "../../../Common/Components/TimePicker";
import { CostRender, ConvertDate } from "../../../Common/Function/index";
import ActiveList from "../Athlethes/Pages/ActiveList";
import Footer from "./Components/Footer";
import MemoIncomeIcon from "./Components/Icons/IncomeIcon";
import PercentageIcon from "./Components/Icons/PercentageIcon";
import { dashboardManager, payGhest } from "./Components/Services";
import Table from "./Components/Table";
import VerticalCard from "./Components/VerticalCard";

function Manager() {
  const { user } = useSelector(state => state);
  const dispatch = useDispatch();
  const [form, setForm] = useState({
    trackingcodeorder: "",
    mobile: "",
    visible: false,
    selectItem: false,
  });
  const store = async data => {
    setstate({ ...state, loadingReserve: true });
    await payGhest(data).then(() => {
      setstate({ ...state, loadingReserve: false });
    });
  };
  const [tracking, setTracking] = useState({ trackingcodeorder: "" });

  const initialState = {
    loading: true,
    data: null,
  };
  const [state, setstate] = useState(initialState);
  const [loadingBtn, setLoadingBtn] = useState(false);

  useEffect(() => {
    if (!form.visible) {
      Handler();
    }
  }, [form.visible]);

  const Handler = (data = null) => {
    setstate({ ...state, loading: true });
    dashboardManager(data).then(result => {
      setstate({
        loading: false,
        data: result,
      });
    });
  };
  const navigate = useNavigate();
  const getOrder = async init => {
    setLoadingBtn(preventLoading => !preventLoading);
    return await Get({
      url: "/order/manager_order_details",
      data: { ...tracking },
    }).then(response => {
      if (response) {
        navigate("/User/OrderDetails/" + tracking.trackingcodeorder);
      }
      setLoadingBtn(preventLoading => !preventLoading);
    });
  };

  if (user && user.item && user.item[0] && user.item.length > 1) {
    return (
      <Fragment>
        <Helmet>
          <title>نیکوتن | داشبورد کاربری</title>
        </Helmet>
        <div id="select-item">
          <div className="row justify-content-center">
            <div className=" col-10 col-lg-8">
              <h4 style={{ fontWeight: "500" }}>مدیر عزیز </h4>
              <p style={{ fontWeight: "400" }}>
                با شماره شما در سامانه نیکوتن {user.item.length} مجموعه ثبت شده
                است برای ادامه کار لطفا مجموعه مورد نظر را انتخاب کنید{" "}
              </p>
              <p style={{ fontWeight: "400" }}>
                پنل فقط در صورت انتخاب مجموعه برای شما باز خواهد شد
              </p>
            </div>
          </div>
          <div className="row justify-content-center">
            {user.item.map((item, key) => {
              return (
                <BoxShadow
                  className=" col-10 col-lg-8"
                  style={{
                    display: "flex",
                    marginBottom: "20px",
                    backgroundColor: Color.white,
                    overflow: "hidden",
                    padding: "9px",
                    cursor: "pointer",
                  }}
                  key={key}
                  method={() => {
                    dispatch({
                      local_storage: {
                        key: "user",
                        value: {
                          ...user,
                          item: user.item.filter(sa => sa.id === item.id),
                        },
                      },
                      type: "SET",
                      payload: {
                        user: {
                          ...user,
                          item: user.item.filter(sa => sa.id === item.id),
                        },
                      },
                    });
                  }}
                >
                  <div style={{}}>
                    <img
                      style={{
                        // width: WidthPercent(select.id == item.id ? 38 : 35),
                        // height: WidthPercent(select.id == item.id ? 23 : 20),
                        // borderRadius: WidthPercent(1.5),
                        width: window.innerWidth < 400 ? "140px" : "200px",
                        height: window.innerWidth < 400 ? "140px" : "200px",
                        borderRadius: "5px",
                      }}
                      src={item.images && item.images[0]}
                    />
                  </div>
                  <div
                    style={{
                      justifyContent: "space-between",
                      flex: 1,
                      alignItems: "stretch",
                      marginRight: "10px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <h6
                      style={{
                        fontSize: "18px",
                      }}
                    >
                      {item.name}
                    </h6>
                    <div style={{ flexDirection: "row", alignItems: "center" }}>
                      {/* <MaterialIcons
                      name="location-pin"
                      color={Color.primary}
                      style={{}}
                    /> */}
                      <h6
                        style={{
                          color: Color.textSecondry,
                          fontWeight: "400",
                        }}
                      >
                        {`${item.province && item.province[0].name} ، ${item.city && item.city[0].name
                          }`}
                      </h6>
                    </div>
                    <div style={{ flexDirection: "row", alignItems: "center" }}>
                      {/* <MaterialIcons
                      name="location-pin"
                      color={Color.primary}
                      style={{}}
                    /> */}
                      <h6
                        style={{
                          fontWeight: "400",
                          color: Color.textSecondry,
                        }}
                      >
                        {" "}
                        {`${cutText(item && item.address, 40)}`}
                      </h6>
                    </div>
                    <div className="d-flex justify-content-end">
                      <button className="btn btn-primary" onClick={() => { }}>
                        انتخاب
                      </button>
                    </div>
                  </div>
                </BoxShadow>
              );
            })}
          </div>
        </div>
      </Fragment>
    );
  }
  const renderAccess = () => {
    if (user.item[0] && user.item[0].timetable_option) {
      if (user.item[0].timetable_option.needdate == "true") {
        if (user.item[0].timetable_showmodel == "table") {
          return (
            <>
              <div className="row justify-content-between flexBoxDashboardItem">
                <VerticalCard
                  value={"امکان ثبت رزرو قراردادی در بازه و تایم های مشخص"}
                  src={window.origin + "/img/contract.png"}
                  title={"رزرو قراردادی"}
                  className="col-md-6 mb-sm-3 mb-2 miniColBox2"
                  access={{
                    method: () => {
                      navigate("/User/Contract");
                    },
                    style: { cursor: "pointer" },
                  }}
                />
                <VerticalCard
                  value={"رزرو سریع تایم مشخص برای کاربران"}
                  src={window.origin + "/img/recruiting.png"}
                  title={"رزرو سریع"}
                  className="col-md-6 miniColBox2 mb-sm-3 mb-2"
                  access={{
                    method: () => {
                      setForm({ ...form, visible: true, step: 1 });
                    },
                    style: { cursor: "pointer" },
                  }}
                />
              </div>
            </>
          );
        } else {
          return (
            <>
              <div className="row justify-content-between mb-3 flexBoxDashboardItem">
                <VerticalCard
                  value={"رزرو سریع تایم مشخص برای کاربران"}
                  src={window.origin + "/img/recruiting.png"}
                  title={"رزرو سریع"}
                  className="col-md-6 "
                  access={{
                    method: () => {
                      setForm({ ...form, visible: true, step: 1 });
                    },
                    style: { cursor: "pointer" },
                  }}
                />
              </div>
            </>
          );
        }
      } else {
        return (
          <div className="row justify-content-between mb-3 flexBoxDashboardItem">
            <VerticalCard
              value={"ثبت حضور با مشاهده ورزشکاران فعال"}
              src={window.origin + "/img/vote.png"}
              title={"ثبت جلسه"}
              className="col-md-6 mb-3"
              access={{
                method: () => {
                  setForm({ ...form, visible: true, step: "PA" });
                },
                style: { cursor: "pointer" },
              }}
            />
            <VerticalCard
              value={"رزرو سریع تایم مشخص برای کاربران"}
              src={window.origin + "/img/recruiting.png"}
              title={"رزرو سریع"}
              className="col-md-6 "
              access={{
                method: () => {
                  setForm({ ...form, visible: true, step: 1 });
                },
                style: { cursor: "pointer" },
              }}
            />
          </div>
        );
      }
    } else {
      return <></>;
    }
  };
  const renderHeader = () => {
    switch (form.step) {
      case 1:
        return "رزرو سریع";
        break;
      case "PA":
        return "ثبت حضور";
      default:
        break;
    }
  };
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | داشبورد کاربری</title>
      </Helmet>
      <div className="">
        <div className="card-body cardBoxDashboard">
          {state.loading ? (
            <Loading count={1} col={12} height={400} />
          ) : (
            <Fragment>
              <div className="row flexBoxDashboardItem">
                <VerticalCard
                  value={CostRender.format(
                    state.data && state.data.total_income
                  )}
                  src={window.origin + "/img/wallet.png"}
                  title={"مجموع کل درآمد"}
                  amount="تومان"
                  className="col-xl-3 col-md-4 col-6 mb-sm-3 mb-2 rounded-5 miniColBox"
                />
                <VerticalCard
                  value={CostRender.format(state.data && state.data.sellwallet)}
                  src={window.origin + "/img/score.png"}
                  title={"درآمد قابل برداشت"}
                  amount="تومان"
                  className="col-xl-3 col-md-4 col-6 mb-sm-3 mb-2 miniColBox"
                />
                <VerticalCard
                  value={state.data.reserve_count}
                  src={window.origin + "/img/reserve.png"}
                  title={"تعداد کل سفارشات "}
                  className="col-xl-3 col-md-4 col-6 mb-sm-3 mb-2 miniColBox"
                />
                <VerticalCard
                  value={state.data.new_resrve_count}
                  src={window.origin + "/img/new.png"}
                  title={" سفارشات جدید"}
                  className="col-xl-3 col-md-4 col-6 mb-sm-3 mb-2 miniColBox"
                />
              </div>
              {+state.data.countitem > 1 && (
                <div className="row flexBoxDashboardItem">
                  <VerticalCard
                    value={`مدیر عزیز با شماره شما در سامانه نیکوتن ${state.data.countitem} مجموعه ثبت شده`}
                    src={window.origin + "/img/choice.png"}
                    title={`انتخاب مجموعه - ${user.item && user.item[0].name}`}
                    className="col-12 mb-sm-3 mb-2 miniColBox2"
                    access={{
                      method: () => {
                        setForm({ selectItem: true });
                      },
                      style: { cursor: "pointer" },
                    }}
                  />
                </div>
              )}
              {renderAccess()}

              <BoxShadow
                className={"orderTrackingBox"}
              >
                <div className="">
                  <h5>پیگیری سفارش</h5>
                  <div className="d-flex mt-2">
                    <TextField
                      fullWidth
                      label="کد پیگیری بلیت را وارد کنید"
                      InputProps={{}}
                      size="small"
                      type="number"
                      onKeyDown={e => {
                        if (e.key == "Enter") {
                          getOrder();
                        }
                      }}
                      onChange={({ target: { value } }) => {
                        setTracking({ trackingcodeorder: value });
                      }}
                    />
                    <button
                      className="btn btn-primary mr-3 "
                      style={{
                        width: "80px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={getOrder}
                      disabled={loadingBtn}
                    >
                      {loadingBtn ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "پیگیری"
                      )}
                    </button>
                  </div>
                </div>
              </BoxShadow>
              {state && state.data && state.data.conghset && (
                <div className="row mt-3">
                  <Table
                    title={"صورتحساب قراداد ها"}
                    lastText={""}
                    textEmpty={"صورتحسابی ندارید"}
                    col="col-12"
                    form={[
                      { key: "item_name", name: "نام مجموعه" },
                      { key: "trackingcodeorder", name: "کد پیگیری" },
                      { key: "price", name: "مبلغ قابل پرداخت" },
                      {
                        key: "pay_exp_time",
                        name: "مهلت پرداخت",
                        format: "date",
                      },
                    ]}
                    data={state.data.conghset}
                    to={"/User/Reserves"}
                    btn={{
                      text: "پرداخت صورتحساب",
                      metod: tr => {
                        store(tr);
                      },
                      loading: state.loadingReserve,
                    }}
                  />
                </div>
              )}
              <div className="col-12 p-0 mt-4">
                <h5>آخرین سفارشات</h5>
                <div className="tbBoxLatestOrders">
                  <OrderList short={5} />
                </div>
              </div>
              <div className="col-12 px-0">
                <div className="row  mt-4 ">
                  <LineChart line={state.data.chart_sell} />
                  <div className="col-md-4 mt-md-0 mt-4">
                    <HorizentalCard
                      value={state.data.week_income}
                      title={"درآمد هفتگی"}
                      IconComponent={MemoIncomeIcon}
                    />
                    <HorizentalCard
                      value={state.data.week_income_percentage}
                      title={"درصد افزایش درآمد"}
                      IconComponent={PercentageIcon}
                    />
                  </div>
                </div>
              </div>

              <div className="col-12 p-0 mt-4">
                <h5>آخرین نظرات</h5>
                <div className="tbBoxLatestOrders">
                  <DataTable
                    data={state.data.last_comment}
                    list={state.data.last_comment}
                    heads={[
                      {
                        title: "نام",
                        key: "comenter",
                        keyName: "fullname",
                      },

                      {
                        title: "متن",
                        key: "text",
                      },
                      {
                        title: "زمان",
                        key: "created_at",
                        type: "date",
                        timetype: "date-time",
                      },
                    ]}
                    short={5}
                  />
                </div>
              </div>
              <Footer />
            </Fragment>
          )}
        </div>
      </div>
      <CustomModal
        header={renderHeader()}
        show={form.visible}
        handleClose={() => {
          setForm({ visible: false });
        }}
        className={"modalQuickReserve"}
      >
        <QuickReserve form={form} setForm={setForm} />
      </CustomModal>

      <CustomModal
        header={"انتخاب مجموعه"}
        show={form.selectItem}
        handleClose={() => {
          setForm({ selectItem: false });
        }}
      >
        <SelectItem setForm={setForm} dispatch={dispatch} user={user} />
      </CustomModal>

    </Fragment>
  );
}
const SelectItem = ({ setForm, dispatch, user }) => {
  const { list, loading, getItems } = useSelectItem();
  // const dispatch = useDispatch();
  useEffect(() => {
    getItems();
  }, []);
  if (loading) {
    return <Loading count={3} height={200} />;
  }
  return (
    <>
      <div className="row justify-content-center">
        {list.item.map((item, key) => {
          return (
            <BoxShadow
              key={key}
              className="col-lg-8"
              style={{
                display: "flex",
                marginBottom: "20px",
                backgroundColor: Color.white,
                overflow: "hidden",
                padding: "9px",
                cursor: "pointer",
              }}
              method={() => {
                dispatch({
                  local_storage: {
                    key: "user",
                    value: {
                      ...user,
                      item: [{ ...item, itemtype: "active" }],
                      itemtype: "active",
                    },
                  },
                  type: "SET",
                  payload: {
                    user: {
                      ...user,
                      item: [{ ...item, itemtype: "active" }],
                      itemtype: "active",
                    },
                  },
                });
                setForm({ selectItem: false });
                window.location.reload();
              }}
            >
              <div className="d-flex align-items-center">
                <img
                  style={{
                    // width: WidthPercent(select.id == item.id ? 38 : 35),
                    // height: WidthPercent(select.id == item.id ? 23 : 20),
                    // borderRadius: WidthPercent(1.5),
                    width: window.screen.width < 576 ? "130px" : "200px",
                    height: window.screen.width < 576 ? "80px" : "145px",
                    borderRadius: "5px",
                  }}
                  src={item.images && item.images[0]}
                />
              </div>
              <div
                style={{
                  justifyContent: "space-between",
                  flex: 1,
                  alignItems: "stretch",
                  marginRight: "10px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h6
                  style={{
                    fontSize: "18px",
                  }}
                >
                  {item.name}
                </h6>
                <div style={{ flexDirection: "row", alignItems: "center" }}>
                  {/* <MaterialIcons
                      name="location-pin"
                      color={Color.primary}
                      style={{}}
                    /> */}
                  <h6
                    style={{
                      color: Color.textSecondry,
                      fontWeight: "400",
                    }}
                  >
                    {`${item.province && item.province[0].name} ، ${item.city && item.city[0].name
                      }`}
                  </h6>
                </div>
                <div style={{ flexDirection: "row", alignItems: "center" }}>
                  {/* <MaterialIcons
                      name="location-pin"
                      color={Color.primary}
                      style={{}}
                    /> */}
                  <h6
                    style={{
                      fontWeight: "400",
                      color: Color.textSecondry,
                    }}
                  >
                    {`${cutText(item && item.address, 40)}`}
                  </h6>
                </div>
                <div className="d-flex justify-content-end">
                  <button className="btn btn-primary" onClick={() => { }}>
                    انتخاب
                  </button>
                </div>
              </div>
            </BoxShadow>
          );
        })}
      </div>
    </>
  );
};
const QuickReserve = ({ form, setForm }) => {
  const { user } = useSelector(state => state);
  const [loading, setloading] = useState({});
  const checkMobile = async (modal, setModal) => {
    setloading({ btn: true });
    await Get({ url: "/manager/check_user", data: form }).then(response => {
      setloading({ btn: false });
      if (response.user) {
        setForm({ ...form, ...response, step: "reserve" });
      } else {
        setForm({ ...form, step: "newuser" });
      }
    });
  };
  const renderState = data => {
    if (data && data != "false" && data.length !== 10) {
      return false;
    } else {
      if (data && data.length === 10) {
        return true;
      } else {
        return false;
      }
    }
  };
  const reserve = async data => {
    setloading({ reserve: true });

    await Set({
      url: "/manager/buy_foruser",
      data: data,
    }).then(response => {
      setForm({ mobile: "" });
      setloading({ reserve: false });
    });
  };
  const confirm = async data => {
    setloading({ ...loading, absent: true });
    Set({
      url: "/order/confirm_pa",
      data: data,
    }).then(res => {
      setloading({ ...loading, absent: false });
      setForm({});
    });
  };

  switch (form.step) {
    case "PA":
      return <ActiveList form={form} setForm={setForm} />;
    case "time":
      return (
        <>
          <div className=" mb-2 d-flex align-items-center">
            <div>
              <h6>تاریخ مورد نظر برای ثبت حضور انتخاب کنید</h6>
              <p style={{ fontWeight: "400", fontSize: "14px" }}>
                {form.athele.fullname} - {form.athele.mobile} -{" "}
                {form.athele.national_code}
              </p>
            </div>

            <div className="d-flex justify-content-end" style={{ flex: 1 }}>
              <div style={{}}>
                <button
                  className="btn btn-success"
                  onClick={() => {
                    confirm({
                      type: "now",

                      reseves: form.athele.reserve_id,
                      ...form.athele,
                    });
                  }}
                >
                  {loading.absent ? "در حال ثبت" : "اکنون"}
                </button>
              </div>
              <div>
                <button
                  className="btn btn-danger mr-2"
                  onClick={() => {
                    setForm({ ...form, step: "selectDate" });
                  }}
                >
                  تاریخ دیگر
                </button>
              </div>
            </div>
          </div>
        </>
      );
    case "selectDate":
      return (
        <div>
          <h6>لطفا تاریخ و ساعت حضور را وارد کنید</h6>
          <div className="mt-4">
            <TimePicker
              form={form}
              setForm={setForm}
              element={{
                key: "time",
                name: "ساعت حضور",
              }}
            />{" "}
          </div>
          <div className={`my-2`}>
            <label
              // className={`${labelStyle ? "bg-success" : "bg-danger"}`}
              htmlFor=""
            >
              تاریخ حضور
            </label>
            <Calendar
              // range={true}
              onChange={data => {
                setForm({
                  ...form,
                  date: ConvertDate(
                    `${data.year}/${data.month.number}/${data.day}`
                  ),
                });
              }}
              calendar={persian}
              // multiple={true}
              locale={persian_fa}
            />
            <div className="mt-3 d-flex justify-content-center">
              <button
                disabled={!(form.date && form.time)}
                onClick={() => {
                  confirm({
                    type: "withdate",
                    ...form,
                    reseves: form.athele.reserve_id,
                    ...form.athele,
                  });
                }}
                className={`btn d-flex justify-content-center btn-danger
                  `}
                style={{ width: "120px" }}
              >
                {!loading.absent ? "ثبت" : "در حال ارسال"}
              </button>
            </div>
          </div>
        </div>
      );
    case 1:
      return (
        <div>
          <div className="row justify-content-center">
            <div className="col">
              <div className="nameTitleModal">
                <h5 className="text-center">مدیر مجموعه عزیز 11</h5>
                <p className="text-center" style={{ fontWeight: "400", fontSize: "14" }} >
                  تایم مورد نظر خود را انتخاب کنید
                </p>
              </div>
              <div className="">

              </div>
            </div>
          </div>
          <EditItem
            fsReserv={true}
            reserve={{
              state: true,
              method: time => {
                setForm({ ...time, ...form, step: 2 });
              },
            }}
          />
        </div>
      );
    case 2:
      return (
        <div className="container">
          <div className="row justify-content-center mb-4">
            <div className="col-md-6">
              <h6
                className="text-center"
                style={{ fontSize: "20px", margin: 0 }}
              >
                مدیر مجموعه عزیز
              </h6>
              <p className="text-center"
                style={{ fontSize: "16px", margin: "0" }}
              >
                برای رزرو ، شماره موبایل کاربر مورد نظر را وارد کنید
              </p>
            </div>
          </div>{" "}
          <div className="row mt-3 justify-content-center ">
            <div className="col-md-6">
              <div className="form-group d-flex">
                <TextField
                  fullWidth
                  label={"شماره موبایل"}
                  size="small"
                  onChange={({ target: { value } }) => {
                    setForm({
                      ...form,
                      result: { user: "no" },
                      mobile: value,
                    });
                  }}
                  type="number"
                  length="11"
                />
                <button
                  onClick={() => checkMobile()}
                  className="btn btn-primary mr-2"
                  disabled={
                    loading.btn || (form.mobile && form.mobile.length < 10)
                  }
                >
                  {loading.btn ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "ثبت"
                  )}
                </button>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            {/* <div className="col-md-6">{renderComponent()}</div> */}
          </div>
        </div>
      );
    case "reserve":
      return (
        <div className="mt-4 ">
          <p className="" style={{ fontWeight: "400" }}>
            کد ملی کاربر ضروری است
          </p>
          {user.item[0] &&
            user.item[0].timetable_option &&
            user.item[0].timetable_option.needdate == "false" && (
              <p className="mb-4" style={{ fontWeight: "400" }}>
                در صورت نیاز به ثبت تاریخ رزرو به صورت دستی ، روی ثبت تاریخ کلیک
                کنید
              </p>
            )}

          <div className="form-group">
            <TextField
              fullWidth
              label="نام و نام خانوادگی "
              size="small"
              value={form.fullname}
              disabled
            />
          </div>
          <div className="form-group">
            <TextField
              fullWidth
              label="کد ملی"
              size="small"
              type="number"
              value={form.national_code == false ? "" : form.national_code}
              disabled={renderState(form.national_code)}
              onChange={({ target: { value } }) => {
                setForm({
                  ...form,
                  national_code: value,
                });
              }}
            />
          </div>
          <div className="form-group">
            <TextField
              fullWidth
              label="شماره"
              size="small"
              type="number"
              value={form.mobile}
              disabled={form.mobile}
            />
          </div>
          {user.item[0] &&
            user.item[0].timetable_option &&
            user.item[0].timetable_option.needdate == "false" && (
              <div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultValue
                    id="flexCheckDefault"
                    onChange={() => {
                      setForm({
                        ...form,
                        spesificdate: !form.spesificdate,
                      });
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckDefault"
                  >
                    ثبت تاریخ
                  </label>
                </div>
              </div>
            )}

          {form.spesificdate && (
            <div>
              <label
                // className={`${labelStyle ? "bg-success" : "bg-danger"}`}
                htmlFor=""
              >
                تاریخ حضور
              </label>
              <Calendar
                // range={true}
                onChange={data => {
                  setForm({
                    ...form,
                    spesificdate: ConvertDate(
                      `${data.year}/${data.month.number}/${data.day}`
                    ),
                  });
                }}
                calendar={persian}
                // multiple={true}
                locale={persian_fa}
              />
            </div>
          )}

          <div className="mt-4">
            <button
              className="btn btn-primary btn-block"
              onClick={() =>
                reserve({
                  timekey: form.id,
                  daykey: form.daykey,
                  ...form,
                })
              }
              disabled={
                loading.reserve ||
                !form.mobile ||
                !form.national_code ||
                !form.fullname
              }
            >
              {loading.reserve ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "رزرو"
              )}
            </button>
          </div>
        </div>
      );
    case "newuser":
      return (
        <div>
          <div className="form-group ">
            <label htmlFor="exampleInputEmail1">نام</label>
            <input
              className="form-control"
              onChange={({ target: { value } }) => {
                setForm({ ...form, fullname: value });
              }}
            />
          </div>
          <div className="form-group">
            <label htmlFor="exampleInputPassword1">کد ملی</label>
            <input
              type="number"
              className="form-control"
              onChange={({ target: { value } }) => {
                setForm({ ...form, national_code: value });
              }}
            />
          </div>
          <div className="form-group">
            <label htmlFor="exampleInputPassword1">شماره</label>
            <input
              type="number"
              className="form-control"
              value={form.mobile}
              disabled
            />
          </div>
          {user.item[0] &&
            user.item[0].timetable_option &&
            user.item[0].timetable_option.needdate == "false" && (
              <div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultValue
                    id="flexCheckDefault"
                    onChange={() => {
                      setForm({
                        ...form,
                        spesificdate: !form.spesificdate,
                      });
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckDefault"
                  >
                    ثبت تاریخ
                  </label>
                </div>
              </div>
            )}

          {form.spesificdate && (
            <div>
              <label
                // className={`${labelStyle ? "bg-success" : "bg-danger"}`}
                htmlFor=""
              >
                تاریخ حضور
              </label>
              <Calendar
                // range={true}
                onChange={data => {
                  setForm({
                    ...form,
                    spesificdate: ConvertDate(
                      `${data.year}/${data.month.number}/${data.day}`
                    ),
                  });
                }}
                calendar={persian}
                // multiple={true}
                locale={persian_fa}
              />
            </div>
          )}

          <div className="mt-4">
            <button
              className="btn btn-primary btn-block"
              onClick={() =>
                reserve({
                  timekey: form.id,
                  daykey: form.daykey,
                  ...form,
                })
              }
              disabled={
                loading.reserve ||
                !form.mobile ||
                !form.national_code ||
                !form.fullname
              }
            >
              {loading.reserve ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "رزرو"
              )}
            </button>
          </div>
        </div>
      );
    case 2:
      break;
    case 3:
      break;
    default:
      break;
  }

  return <div></div>;
};
export default Manager;
export const useSelectItem = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const getItems = async data => {
    setLoading(true);
    await Get({
      url: "/manager/itemsl",
    }).then(response => {
      if (response) {
        setList(response);
      }
      setLoading(false);
    });
  };
  return {
    list,
    loading,
    getItems,
  };
};
